import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82f82e32"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  title: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    disabled: __props.disabled
  }, [
    _createTextVNode(_toDisplayString(__props.title) + " ", 1),
    _renderSlot(_ctx.$slots, "icon")
  ], 8, _hoisted_1))
}
}

})